import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary:    { main: '#1565C0', contrastText: '#fff' },
    secondary:  { main: '#0d47a1' },
    background: { default: '#f5f6fa', paper: '#ffffff' },
    error:      { main: '#d32f2f' },
    warning:    { main: '#ed6c02' },
    success:    { main: '#2e7d32' },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 500 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, borderRadius: 8 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { boxShadow: '0 2px 12px rgba(0,0,0,0.07)', borderRadius: 12 },
      },
    },
    MuiTextField: {
      defaultProps: { size: 'small' },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: '#1565C0',
            color: '#fff',
            fontWeight: 600,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 6 },
      },
    },
    // On phone-sized viewports we want every dialog to feel native — no
    // tiny floating cards. Stretching the paper to fill the screen with
    // a small inset gives a fullscreen feel without breaking layouts
    // that rely on Dialog being scrollable internally.
    MuiDialog: {
      styleOverrides: {
        paper: ({ theme }) => ({
          [theme.breakpoints.down('sm')]: {
            margin: 8,
            width: 'calc(100% - 16px)',
            maxWidth: 'calc(100% - 16px)',
            maxHeight: 'calc(100% - 16px)',
            borderRadius: 12,
          },
        }),
      },
    },
    // Default DialogContent padding is 24px which is wasteful on small
    // screens — tighten it.
    MuiDialogContent: {
      styleOverrides: {
        root: ({ theme }) => ({
          [theme.breakpoints.down('sm')]: {
            padding: 12,
          },
        }),
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: ({ theme }) => ({
          [theme.breakpoints.down('sm')]: {
            padding: '12px 16px',
            fontSize: 16,
          },
        }),
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: ({ theme }) => ({
          [theme.breakpoints.down('sm')]: {
            padding: 12,
            gap: 8,
          },
        }),
      },
    },
    // Bump default touch targets so phones meet the ≥44px guideline.
    MuiIconButton: {
      styleOverrides: {
        sizeSmall: { padding: 6 },
      },
    },
  },
});

export default theme;
